import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { Activity, ActivityCollection } from './activity.model';
import {
  Review,
  ReviewCollection,
} from 'src/app/shared/review-form/review.model';
import { toArray } from 'rxjs/operators';
import { filter } from 'jszip';
import { map } from 'rxjs/operators';

const API_URL = environment.apiUrl;

@Injectable()
export class ActivitiesService {
  constructor(private http: HttpClient) {}

  public postActivity(activity): Observable<Activity> {
    return this.http.post<Activity>(API_URL + '/activities', activity);
  }

  public getActivity(id: string, language = 'es'): Observable<Activity> {
    return this.http.get<Activity>(API_URL + '/activities/' + id, {
      headers: {
        'Accept-Language': language,
      },
    });
  }

  public getActivityBySlug(
    slug: string,
    language = 'es'
  ): Observable<Activity> {
    return this.http.get<Activity>(API_URL + '/activities?slug=' + slug, {
      headers: {
        'Accept-Language': language,
      },
    });
  }

  public getActivityBySlugPro(
    slug: string,
    language = 'es'
  ): Observable<Activity> {
    return this.http.get<Activity>(API_URL + '/activity_by_slug/' + slug, {
      headers: {
        'Accept-Language': language,
      },
    });
  }

  public getActivitiesById(ids: [string], language): Observable<Activity> {
    let idsString = ids.map((id) => `id[]=${id}`).join('&');
    return this.http.get<Activity>(API_URL + '/activities?' + idsString, {
      headers: {
        'Accept-Language': language,
      },
    });
  }

  public getLastActivities(language): Observable<Activity> {
    return this.http.get<Activity>(API_URL + '/activities?isActive=true', {
      headers: {
        'Accept-Language': language,
      },
    });
  }

  public getActivitiesByMakerId(
    makerId: number,
    filters?: any,
    language = 'es'
  ): Observable<ActivityCollection> {
    if (filters === undefined) {
      filters = {};
    }

    let httpParams = new HttpParams();

    if (filters['name']) {
      httpParams = httpParams.set('name', String(filters.name));
    }
    if (filters['location']) {
      httpParams = httpParams.set('location.name', String(filters.location));
    }
    if (filters['id']) {
      httpParams = httpParams.set('id', String(filters.id));
    }
    if (filters['localidad']) {
      httpParams = httpParams.set('location.id', String(filters.localidad));
    }
    if (filters['categorias']) {
      filters.categorias
        .split(',')
        .forEach(
          (category) =>
            (httpParams = httpParams.append('categories.id[]', category))
        );
    }
    return this.http.get<ActivityCollection>(
      API_URL + '/activities?isActive=true&supplier.id=' + makerId,
      {
        params: httpParams,
        headers: {
          'Accept-Language': language,
        },
      }
    );
  }

  public getAllActivitiesByMakerId(
    makerId: number,
    filters?: any,
    language = 'es'
  ): Observable<ActivityCollection> {
    if (filters === undefined) {
      filters = {};
    }

    let httpParams = new HttpParams();

    if (filters['name']) {
      httpParams = httpParams.set('name', String(filters.name));
    }
    if (filters['location']) {
      httpParams = httpParams.set('location.name', String(filters.location));
    }
    if (filters['id']) {
      httpParams = httpParams.set('id', String(filters.id));
    }
    if (filters['localidad']) {
      httpParams = httpParams.set('location.id', String(filters.localidad));
    }
    if (filters['categorias']) {
      filters.categorias
        .split(',')
        .forEach(
          (category) =>
            (httpParams = httpParams.append('categories.id[]', category))
        );
    }
    return this.http.get<ActivityCollection>(
      API_URL + '/suppliers/' + makerId + '/activities',
      {
        params: httpParams,
        headers: {
          'Accept-Language': language,
        },
      }
    );
  }

  public getActivitiesByTakerId(
    takerId: number
  ): Observable<ActivityCollection> {
    return this.http.get<ActivityCollection>(
      API_URL + '/takers/' + takerId + '/favorite_experiences'
    );
  }

  public getActivitiesByResellerId(
    resellerId: number,
    filters: any
  ): Observable<ActivityCollection> {
    if (filters === undefined) {
      filters = {};
    }

    let httpParams = new HttpParams();

    if (filters['name']) {
      httpParams = httpParams.set('experience.name', String(filters.name));
    }
    if (filters['location']) {
      httpParams = httpParams.set(
        'experience.location.name',
        String(filters.location)
      );
    }
    if (filters['id']) {
      httpParams = httpParams.set('experience.id', String(filters.id));
    }
    if (filters['maker']) {
      httpParams = httpParams.append(
        'experience.maker.name',
        String(filters.maker)
      );
    }
    if (filters['tags']) {
      filters.tags.forEach(
        (tag) => (httpParams = httpParams.append('experience.tags.id[]', tag))
      );
    }
    if (filters['locations']) {
      filters.locations.forEach(
        (location) =>
          (httpParams = httpParams.append('experience.location.id[]', location))
      );
    }

    return this.http.get<ActivityCollection>(
      API_URL + '/resellers/' + resellerId + '/favorite_experiences',
      { params: httpParams }
    );
  }

  public getActivityByCivitatisId(
    id: string,
    language = 'es'
  ): Observable<Activity> {
    return this.http.get<Activity>(API_URL + '/activities?civitatisId=' + id, {
      headers: {
        'Accept-Language': language,
      },
    });
  }

  public getActivitiesByUrl(
    filters: any,
    language
  ): Observable<ActivityCollection> {
    let httpParams = new HttpParams();

    console.log(filters);
    
    filters.forEach((value, key) => {
      if (key == 'name') {
        httpParams = httpParams.set('name', String(value));
      }
      if (key == 'location') {
        httpParams = httpParams.set('location.name', String(value));
      }
      console.log(key);
      
      console.log(httpParams);
      
      if (key == 'id') {
        httpParams = httpParams.set('id', String(value));
      }
      if (key == 'localidad') {
        httpParams = httpParams.set('location.id', String(value));
      }
      if (key == 'zonas') {
        httpParams = httpParams.append('zones.id', String(value));
      }
      if (key == 'zone') {
        httpParams = httpParams.append('zones.name', String(value));
      }
      if (key == 'categorias') {
        value
          .split(',')
          .forEach(
            (category) =>
              (httpParams = httpParams.append('categories.id[]', category))
          );
      }
      if (key == 'etiquetas') {
        value
          .split(',')
          .forEach((tag) => (httpParams = httpParams.append('tags.id[]', tag)));
      }

      if (key == 'maker') {
        httpParams = httpParams.append('maker.name', String(value));
      }
      if (key == 'tags') {
        value.forEach(
          (tag) => (httpParams = httpParams.append('tags.id[]', tag))
        );
      }
      if (key == 'locations') {
        value.forEach(
          (location) =>
            (httpParams = httpParams.append('location.id[]', location))
        );
      }
      if (key == 'monthsString') {
        httpParams = httpParams.append('monthsString', String(value));
      }
      if (key == 'isFavorites') {
        httpParams = httpParams.append(
          'resellerFavoriteActivitys.reseller.id[]',
          String(filters.resellerId)
        );
      }
      if (key == 'page') {
        httpParams = httpParams.append('page', String(value));
      }
    });

    // if (language === 'en') {
    //   httpParams = httpParams.append('isEnglishChecked', 'true');
    // }

    return this.http.get<ActivityCollection>(
      API_URL +
        '/activities?isActive=true&order[supplier.subscriptionPlan.price]=DESC&exists[name]=true',
      {
        params: httpParams,
        headers: {
          'Accept-Language': language,
        },
      }
    );
  }

  public getActivities(filters: any, language): Observable<ActivityCollection> {
    if (filters === undefined) {
      filters = {};
    }

    let httpParams = new HttpParams();

    if (filters['name']) {
      httpParams = httpParams.set('name', String(filters.name));
    }
    if (filters['location']) {
      httpParams = httpParams.set('location.name', String(filters.location));
    }
    if (filters['id']) {
      httpParams = httpParams.set('id', String(filters.id));
    }
    if (filters['localidad']) {
      httpParams = httpParams.set('location.id', String(filters.localidad));
    }
    if (filters['zonas']) {
      httpParams = httpParams.set('zones.id', String(filters.zona));
    }
    if (filters['categorias']) {
      filters.categorias
        .split(',')
        .forEach(
          (category) =>
            (httpParams = httpParams.append('categories.id[]', category))
        );
    }
    if (filters['etiquetas']) {
      filters.etiquetas
        .split(',')
        .forEach((tag) => (httpParams = httpParams.append('tags.id[]', tag)));
    }

    if (filters['maker']) {
      httpParams = httpParams.append('maker.name', String(filters.maker));
    }
    if (filters['tags']) {
      filters.tags.forEach(
        (tag) => (httpParams = httpParams.append('tags.id[]', tag))
      );
    }
    if (filters['locations']) {
      filters.locations.forEach(
        (location) =>
          (httpParams = httpParams.append('location.id[]', location))
      );
    }
    if (filters['isFavorites']) {
      httpParams = httpParams.append(
        'resellerFavoriteActivities.reseller.id[]',
        String(filters.resellerId)
      );
    }
    if (filters['page']) {
      httpParams = httpParams.append('page', String(filters.page));
    }

    // if (language === 'en') {
    //   httpParams = httpParams.append('isEnglishChecked', 'true');
    // }

    return this.http.get<ActivityCollection>(
      API_URL +
        '/activities?isActive=true&order[supplier.subscriptionPlan.price]=DESC&exists[name]=true',
      {
        params: httpParams,
        headers: {
          'Accept-Language': language,
        },
      }
    );

    // return this.http
    //   .get<ActivityCollection>(API_URL + '/experiences?isActive=true&order[sheetCompleted]&order[maker.sheetCompleted]&order[civitatisId]', {
    //     params: httpParams, headers: {
    //       'Accept-Language': language
    //     }
    //   });
  }

  public getActivitiesByZone(zone: string, language: string) {
    return this.http.get<Activity>(
      API_URL +
        '/activities?isActive=true&exists[name]=true&zones.name=' +
        zone,
      {
        headers: {
          'Accept-Language': language,
        },
      }
    );
  }

  public deleteActivity(experienceId: string): any {
    return this.http.delete<Activity>(API_URL + experienceId);
  }

  public putActivity(
    experienceId: string,
    experience: Activity,
    language = 'es'
  ): Observable<Activity> {
    return this.http.put<Activity>(
      API_URL + '/activities/' + experienceId,
      experience,
      {
        headers: {
          'Accept-Language': language,
        },
      }
    );
  }

  public translateActivity(body: any): Observable<any> {
    return this.http.post<any>(API_URL + '/ia/translate-request', body);
  }

  public importFrom(body: any): Observable<any> {
    return this.http.post<any>(API_URL + '/ia/import-from', body);
  }

  public postModality(modality: any): Observable<any> {
    return this.http.post<any>(API_URL + '/modalities', modality);
  }

  public putModality(modalityIri: string, modality: any): Observable<any> {
    return this.http.put<any>(API_URL + modalityIri, modality);
  }

  public deleteModality(modalityIri: string): Observable<any> {
    return this.http.delete<any>(API_URL + modalityIri);
  }

  public getFileDatas(fileUrls: any): Observable<any> {
    return this.http.post<any>(API_URL + '/downloads/images', fileUrls); // Use 'blob' for binary data
  }

  public postReview(review): Observable<Review> {
    return this.http.post<Review>(API_URL + '/reviews', review);
  }

  public getReviewsByActivityId(
    productId,
    filters?: any,
    language = 'es'
  ): Observable<any> {
    if (filters === undefined) {
      filters = {};
    }

    let httpParams = new HttpParams();

    if (filters['name']) {
      httpParams = httpParams.set('name', String(filters.name));
    }
    if (filters['comments']) {
      httpParams = httpParams.set('comments', String(filters.comments));
    }
    if (filters['reviewerLocation']) {
      httpParams = httpParams.set(
        'reviewerLocation',
        String(filters.reviewerLocation)
      );
    }
    if (filters['date']) {
      httpParams = httpParams.set('date', String(filters.date));
    }
    if (filters['channel']) {
      httpParams = httpParams.set('location.channel', String(filters.channel));
    }

    return this.http.get<ReviewCollection>(
      API_URL + '/activities/' + productId + '/reviews',
      {
        params: httpParams,
        headers: {
          'Accept-Language': language,
        },
      }
    );
  }

  public getValidatedReviewsByActivityId(productId): Observable<any> {
    return this.http.get<ReviewCollection>(
      API_URL + '/activities/' + productId + '/reviews?status=validated'
    );
  }

  public putReviewStatus(reviewId, status): Observable<any> {
    let sendStatus = {
      status: status,
    };
    return this.http.put<any>(API_URL + reviewId, sendStatus);
  }

  public importReviews(makerId): Observable<any> {
    return this.http.get<any>(
      API_URL + '/getyourguide_reviews?makerId=' + makerId
    );
  }

  public updatePosition(mediaActivities): Observable<any> {
    return this.http.post<any>(API_URL + '/updatePosition', {
      mediaActivities,
    });
  }
}
